import {
  collection,
  onSnapshot,
  orderBy,
  query,
  limit,
  type Unsubscribe,
} from "firebase/firestore";
import type { Project } from "@shared/types";
import { projectBasePath } from "@domain/project/paths";
import { db } from "../firebase";
import type { AIObservation } from "@data/functions/projectReviewer";

export interface AIReviewDoc {
  id: string;
  flowName: string;
  promptVersion: string;
  modelUsed: string;
  contextHash: string;
  observations: AIObservation[];
  summary: string;
  tokensIn: number;
  tokensOut: number;
  costUsd: number;
  createdAt: number;
  createdBy: string;
}

/**
 * AI Reviews live under <projectBasePath>/aiReviews/{id}. Each call to
 * projectReviewer persists a doc; we read the latest one to power the
 * inline "!" indicators across Budget / Timeline / Permits.
 */
export const aiReviewRepository = {
  /** Subscribe to the most recent review. Emits null if none exist. */
  watchLatest(
    project: Project,
    onChange: (review: AIReviewDoc | null) => void
  ): Unsubscribe {
    const col = collection(db, projectBasePath(project), "aiReviews");
    const q = query(col, orderBy("createdAt", "desc"), limit(1));
    return onSnapshot(
      q,
      (snap) => {
        if (snap.empty) {
          onChange(null);
          return;
        }
        const doc = snap.docs[0];
        if (!doc) {
          onChange(null);
          return;
        }
        onChange(doc.data() as AIReviewDoc);
      },
      (err) => {
        console.error("[aiReviewRepository.watchLatest]", err);
        onChange(null);
      }
    );
  },
};
